import { ConversationType } from '@shared/generated/graphql';

import { ReactElement } from 'react';
import {
  PiChatTeardropDuotone,
  PiEnvelopeDuotone,
  PiMicrosoftTeamsLogoFill,
  PiPhoneDuotone,
} from 'react-icons/pi';

export function ConversationTypeIcon({
  type,
}: {
  type: ConversationType;
}): ReactElement {
  const className = 'shrink-0 text-gray-500';

  switch (type) {
    case ConversationType.EMAIL:
      return <PiEnvelopeDuotone size={18} className={className} />;
    case ConversationType.PHONE_CALL:
      return <PiPhoneDuotone size={18} className={className} />;
    case ConversationType.SMS:
      return <PiPhoneDuotone size={18} className={className} />;
    case ConversationType.MICROSOFT_TEAMS:
      return <PiMicrosoftTeamsLogoFill size={18} className={className} />;
    case ConversationType.CHAT:
      return <PiChatTeardropDuotone size={18} className={className} />;
    default: {
      throw new Error(`Unknown conversation type: ${type}`);
    }
  }
}
